import { Tooltip } from "@evergis/ui";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MAX_TOOLTIP_ITEMS_LENGTH } from "./const";
import { TooltipTextLine } from "./styled";

type UsersTooltipProps = {
  users: string[];
};

export const UsersTooltip: FC<UsersTooltipProps> = ({ users }) => {
  const { t } = useTranslation("dialogs");
  const tooltipContent = useMemo(
    () => (
      <>
        {users.slice(0, MAX_TOOLTIP_ITEMS_LENGTH).map((username, index) => (
          <TooltipTextLine key={index}>{username}</TooltipTextLine>
        ))}
        {users.length > MAX_TOOLTIP_ITEMS_LENGTH && (
          <TooltipTextLine>
            {t("deleteLayer.more")} {users.length - MAX_TOOLTIP_ITEMS_LENGTH}
          </TooltipTextLine>
        )}
      </>
    ),
    [t, users],
  );

  return (
    <Tooltip content={tooltipContent} placement="right" arrow delay={0.5}>
      {ref => <abbr ref={ref}>{users.length}</abbr>}
    </Tooltip>
  );
};
